import React from 'react';

const RouteStop = ({ stop, pets, onStatusChange, isDriver }) => {
  const pet = pets.find(p => p.id === stop.petId);
  const getStatusColor = () => {
    switch(stop.status) {
      case 'completed': return 'bg-green-100 text-green-800';
      case 'in-progress': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-3 border-l-4 border-cyan-500">
      <div className="flex justify-between items-start">
        <div className="flex items-center">
          <img src={pet.image} alt={pet.name} className="w-12 h-12 rounded-full mr-3" />
          <div>
            <h4 className="font-medium">{pet.name}</h4>
            <p className="text-sm text-gray-500">{pet.address}</p>
            <p className="text-sm font-medium">
              {stop.action === 'pickup' ? 'Recogida' : 'Entrega'}: {stop.scheduledTime}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor()}`}>
            {stop.status === 'completed' ? 'Completado' : 
             stop.status === 'in-progress' ? 'En curso' : 'Pendiente'}
          </span>
          
          {isDriver && stop.status !== 'completed' && (
            <button
              onClick={() => onStatusChange(stop.petId, stop.action, 'in-progress')}
              className="bg-cyan-600 text-white px-3 py-1 rounded text-sm hover:bg-cyan-700"
            >
              {stop.action === 'pickup' ? 'Recoger' : 'Entregar'}
            </button>
          )}
        </div>
      </div>

      {isDriver && (
        <div className="mt-3 flex justify-between items-center">
          <a
            href={`https://www.google.com/maps/dir/?api=1&destination=${pet.coordinates.lat},${pet.coordinates.lng}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-sm text-cyan-600 hover:text-cyan-800"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
            </svg>
            Navegar
          </a>

          {stop.status === 'in-progress' && (
            <button
              onClick={() => onStatusChange(stop.petId, stop.action, 'completed')}
              className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
            >
              Confirmar
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default RouteStop;